"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatResponse = void 0;

var formatResponse = function formatResponse(params) {
  var _params$data = params.data,
      data = _params$data === void 0 ? {} : _params$data,
      _params$error = params.error,
      error = _params$error === void 0 ? "" : _params$error;
  return {
    data: data,
    error: error
  };
};

exports.formatResponse = formatResponse;